import { render, staticRenderFns } from "./StockProductsDialog.vue?vue&type=template&id=6f8423e2"
import script from "./StockProductsDialog.vue?vue&type=script&lang=ts"
export * from "./StockProductsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports